import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import CustomerFeedbackPage from './components/CustomerFeedbackPage';
import Header from './components/Header';
import ErrorPage from './components/ErrorPage';
import ReceiptPage from './components/ReceiptPage';
import './index.scss';

ReactDOM.render(
    <React.StrictMode>
        <BrowserRouter>
            <Header />
            <Routes>
                <Route path="/error" element={<ErrorPage />} />
                <Route path="/receipt" element={<ReceiptPage />} />
                <Route path="/" element={<CustomerFeedbackPage />} />
            </Routes>
        </BrowserRouter>
    </React.StrictMode>,
    document.getElementById('root'),
);
